import { isAppEmbedded } from '~/utils/isAppEmbedded';
import { makeLoader } from '~/utils/routing';

export const { loader, useLoaderData: useAppShellData } = makeLoader(
  ({ params: { store } }, appState) => {
    const isEmbedded = isAppEmbedded();

    const { order, settings } = appState.getState();

    return {
      store,
      isEmbedded,
      localizeKey: settings?.localizeKey,
      footerText: settings?.theme.footerText,
      order,
    };
  },
);
